import React, { useState, useEffect } from 'react';
import ModalWindow from './ModalWindow';
import axios from 'axios';

const InboundConnections = (props) => {

    const [inboundQueues, setInboundQueues] = useState([]); 
    const [connectedInboundQueues, setConnectedInboundQueues] = useState([]); 

    useEffect(() => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/inboundAsteriskQueues`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            setInboundQueues( response.data);
            
            //set connected inbound queues from session storage
            if(sessionStorage.getItem("connectedInboundQueues")){
                setConnectedInboundQueues(JSON.parse(sessionStorage.getItem("connectedInboundQueues")));
            }

        });
    }, []);

    
    useEffect(() => {
        if(props.notifyMethod){
            props.notifyMethod(connectedInboundQueues);
        }
    }, [connectedInboundQueues]);

    const executeUserAMIAction = (action)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/userAMIAction`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: action
        };
        axios(options).then(response => {
            //console.log('🐞DEBUG executeUserAMIAction response:', response);
        });
    }


    const connected=(queue)=>{
        return connectedInboundQueues.some(e => e._id === queue._id)
    }

    const connectToQueue=(queue)=>{
        const inboundQueues = [...connectedInboundQueues];
        if(!connected(queue)){
            inboundQueues.push(queue);
            setConnectedInboundQueues(inboundQueues);
            
            sessionStorage.setItem("connectedInboundQueues", JSON.stringify(inboundQueues));
            
            //sessionStorage.setItem("connectedInboundQueues", JSON.stringify(inboundQueues), { sameSite: "strict", secure: true });
            //window.dispatchEvent(new Event("storage"));
           // window.sessionStorage.setItem("connectedInboundQueues", JSON.stringify(inboundQueues));

            
            executeUserAMIAction({ action:'QUEUEADD', queue:queue.name, type:'inbound', paused:props.userStatus.paused});
            saveConnectedinboundQueuesIntoUser(inboundQueues);

            //after connect to queue, set status as ACTIVE
            props.changeUserStatus({ paused: false, code: 'ACTIVE', desc:'Disponible'});
        }
    }

    const disconnectQueue=(queue)=>{
        const inboundQueues = [...connectedInboundQueues];
        let indexQueue=inboundQueues.findIndex((iqueue)=> iqueue._id === queue._id);
        inboundQueues.splice(indexQueue, 1); 
        setConnectedInboundQueues(inboundQueues);
        
        sessionStorage.setItem("connectedInboundQueues", JSON.stringify(inboundQueues));
        
        //sessionStorage.setItem("connectedInboundQueues", JSON.stringify(inboundQueues), { sameSite: "strict", secure: true });
        //window.dispatchEvent(new Event("storage"));
        
        executeUserAMIAction({ action: 'QUEUEREMOVE', queue: queue.name });
        saveConnectedinboundQueuesIntoUser(inboundQueues);


        let connectedCampaigns=JSON.parse(sessionStorage.getItem("connectedCampaigns"))??[];
        if(inboundQueues.length===0 && connectedCampaigns.length===0){
            props.changeUserStatus({ paused: false, code: 'LOGGED', desc:'En sistema'});
        }  



    }

    const saveConnectedinboundQueuesIntoUser=(queueList)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));       
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/inboundUser`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
             },
            data: {
                inbound: queueList,
            }
        };
        
        axios(options).then(response => {
            if (response.status === 200) {
                console.log('Saved interaction');
            }
        });
    }

    return (
        <ModalWindow closeMethod={()=>{props.closeMethod()}}>
            <h2 className='title'>Inbound</h2>
            <span className="upper subtitle">Seleccione las colas de inbound a las que desea conectarse</span>
            <table className='fullWidth'>
                <tbody>
                    {inboundQueues.map((queue, index) => {
                        return (
                            <tr key={index} className={connected(queue)?'selected full':undefined}>
                                <td>
                                    <span className='companyColor' style={{borderColor:queue.CNY_DETAILS.color}}>{queue.CNY_DETAILS.name}</span>
                                </td>
                                <td>{queue.name}</td>
                                <td>
                                    {!connected(queue)?(
                                        <button className='default outline small forTableRow' onClick={()=>connectToQueue(queue)}>Conectarse</button>
                                    ):(
                                        <button className='default outline small forTableRow' onClick={()=>disconnectQueue(queue)}>Desconectarse</button>
                                    )}
                                </td>
                                
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </ModalWindow>
    );
    
}

export default InboundConnections;
